
import { useEffect, useState } from 'react';
import { useSearchParams,NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faDeleteLeft, faPlusCircle, faSave } from '@fortawesome/free-solid-svg-icons'
import Plan from './components/Plan'
import React from 'react';
import Modal from 'react-modal';
import { db,auth } from './firebase';
import Carrier from './carrier';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
  tableStyle: {
    borderCollapse: 'collapse',
    width: '100%',
  },
  tdStyle: {
    border: '1px solid #dddddd',
    textAlign: 'left',
    padding: '8px',
  },
  thStyle: {
    backgroundColor: '#f2f2f2',
    fontWeight: 'bold',
    textAlign: 'left',
    padding: '8px',
  }
};

Modal.setAppElement('#root');

function Planslucky() {
  const [searchparams] = useSearchParams();
  const [lucky, setLucky] = useState([]);
  const [serverError, setServerError] = useState('');
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState(false);
  const [created, setCreated] = useState(false);
  const [deleted, setDeleted] = useState(false);
  const [user, setUser] = useState(false);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const carrier = searchparams.get("carrier");
  function openModal() {
    setIsOpen(true);
  }

  useEffect(() => {
    const fetchData = () => {
      db.collection('luckyPlans').orderBy('Plan','asc').where('Carrier',"==", carrier).onSnapshot(plansSnapshot => {
        const plansData = [];
        plansSnapshot.forEach(doc => {
          const item = doc.data();
          item.id = doc.id;
          plansData.push(item);
        });
        console.log(plansData)
        setLucky(plansData);
      })
    };

    fetchData();
  }, []);

  function afterOpenModal() {
    
  }

  function closeModal() {
    setIsOpen(false);
    setUser(false);
  }

function firebaselogin(e){
  e.preventDefault();
    const formData = new FormData(e.target);
    const email = formData.get('email');
    const password = formData.get('password');
    auth.signInWithEmailAndPassword(process.env.REACT_APP_EMAIL, password)
    .then((userCredential) => {
      // Signed in
      setUser(true);

    })
    .catch((error) => {
      var errorCode = error.code;
      var errorMessage = error.message;
      console.log(error.message)
    });
}

  function handleChange(id, field, value) {
    setLucky(prevData =>
      prevData.map(lucky => (lucky.id === id ? { ...lucky, [field]: value} : lucky))
    )
  }

  function handleSave(docs) {
    console.log('Lucky: ', lucky)
    console.log('Docs: ', docs)
    if(docs.Dis!="" && docs.Plan!="" && docs.Gigs!="" && docs.Speed!="" && docs.Gigs >=0 && docs.Plan >0){
      if (docs.id) {
        console.log('Saving')
        console.log('Test: ', docs.Dis)
        db.collection('luckyPlans').doc(docs.id).update({ Dis: docs.Dis, Promo: docs.Promo, Carrier: carrier, Gigs: docs.Gigs, Plan: docs.Plan, Speed: docs.Speed }).then(console.log('Saving Completed')).catch((err) => {
          console.log(err)
          setServerError(err)
          setError(true);
          setTimeout(() => setError(false), 3000);
        })
        setSaved(true);
        setTimeout(() => setSaved(false), 3000);
      } else {
        console.log('Test: ', docs.Dis)
        db.collection('luckyPlans').add({ Dis: docs.Dis, Promo: docs.Promo, Carrier: carrier, Gigs: docs.Gigs, Plan: docs.Plan, Speed: docs.Speed }).then(console.log('Added Successfully')).catch((err) => {
          console.log(err)
          console.log('Error')
          setServerError(err)
          setError(true);
          setTimeout(() => setError(false), 3000);
        })
        console.log('Added New')
        setSaved(true);
        setTimeout(() => setSaved(false), 3000);
      }
    }
    else{
      alert('Data not correct')
    }

    
  }

  function handleDelete(docs) {
    
    db.collection('luckyPlans').doc(docs.id).delete().then(()=>{setDeleted(true);setTimeout(() => setDeleted(false), 3000);});
    
    
  }

  function handleNew() {
    const newElement = { Dis: 'Unlimited talk and text', Gigs: '', Plan: '', Promo: '', Carrier: carrier, Speed: '3G' }
    setLucky(oldArray => [...oldArray, newElement]);
    setCreated(true);
    setTimeout(() => setCreated(false), 3000);

  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <>
      {saved && <div style={{ position: 'fixed', top: 10, right: 10, backgroundColor: 'green', color: 'white', padding: '10px', borderRadius: '5px', zIndex: '99999' }}>Saved</div>}
      {error && <div style={{ position: 'fixed', top: 10, right: 10, backgroundColor: 'red', color: 'white', padding: '10px', borderRadius: '5px', zIndex: '99999' }}>Error: {serverError}</div>}
      {deleted && <div style={{ position: 'fixed', top: 10, right: 10, backgroundColor: 'red', color: 'white', padding: '10px', borderRadius: '5px', zIndex: '99999' }}>Deleted</div>}
      {created && <div style={{ position: 'fixed', top: 10, right: 10, backgroundColor: 'green', color: 'white', padding: '10px', borderRadius: '5px', zIndex: '99999' }}>Created</div>}
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-evenly', marginBottom: 10, alignItems: 'center', width: '100%', height: '100%' }}>
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
          <NavLink to="/carrier">
            <FontAwesomeIcon style={{ position: "absolute", marginLeft: 10, marginTop: 25, color: '#663399' }} icon={faArrowLeft} className="fa-2xl" />
          </NavLink>
          <div style={{ width: '100%' }}>
            <h1 style={{ justifySelf: "center", borderBottom: '1px solid #e6e6e6', margin: "0px", padding: "20px" }}>{`Please choose a ${carrier} plan`}</h1>

          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginBottom: 10, alignItems: 'center', width: '100%', height: '100%' }}>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginBottom: 10, alignItems: 'center', width: '100%', height: '100%' }}>
            {lucky && lucky.map((docs, index) => (
              <Plan
                key={index}
                carrier= {carrier}
                planName={`$ ${docs.Plan}`}
                planData={`${docs.Gigs}GB`}
                planInfo={docs.Dis}
                speed = {docs.Speed}
                planPromo={docs.Promo&&`Promo: ${docs.Promo}`}
              />
            ))}
          </div>
        </div>
      </div>

      <div>
        <FontAwesomeIcon
          onClick={openModal}
          style={{ position: "absolute", top: '25px', right: '20px', color: '#663399' }} icon={faPlusCircle} className="fa-2xl" />
        <Modal
          isOpen={modalIsOpen}
          onAfterOpen={afterOpenModal}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >{!user?<form onSubmit={firebaselogin}>
        <div>
          <label>Password: </label>
          <input
            type="password"
            name="password"
            required
          />
        </div>
        <button type="submit">Login</button>
      </form>:<><table styles={customStyles.tableStyle}>
            <tbody>
              <tr>
              <th style={customStyles.thStyle}>Speed</th>
                <th style={customStyles.thStyle}>Plan Cost</th>
                <th style={customStyles.thStyle}>Gigabytes</th>
                <th style={customStyles.thStyle}>Description</th>
                <th style={customStyles.thStyle}>Promotion</th>
                <th style={customStyles.thStyle}>Save</th>
                <th style={customStyles.thStyle}>Delete</th>
              </tr>
              {lucky && lucky.map((docs, index) => (
                <tr>
                  <td style={customStyles.thStyle}>
    <select style={{
        backgroundColor: '#ffffff',
        fontWeight: 'bold',
        borderRadius:'5px',
        border: '1px solid #808080',
        textAlign: 'left',
        padding: '15px',
        width: '100%', // Add this style to make the dropdown match the width of the column
      }} onChange={e => handleChange(docs.id, 'Speed', e.target.value)} value={lucky.Speed} defaultValue={docs.Speed}>
      <option value="3G">3G</option>
      <option value="4G">4G</option>
    </select>
  </td>
                  <td style={customStyles.thStyle}><input type='number' onChange={e => handleChange(docs.id, 'Plan', e.target.value)} value={lucky.Plan} defaultValue={docs.Plan} /></td>
                  <td style={customStyles.thStyle}><input type='number' onChange={e => handleChange(docs.id, 'Gigs', e.target.value)} value={lucky.Gigs} defaultValue={docs.Gigs} /></td>
                  <td style={customStyles.thStyle}><input onChange={e => handleChange(docs.id, 'Dis', e.target.value)} value={lucky.Dis} defaultValue={docs.Dis} /></td>
                  <td style={customStyles.thStyle}><input onChange={e => handleChange(docs.id, 'Promo', e.target.value)} value={lucky.Promo} defaultValue={docs.Promo} /></td>
                  <td style={customStyles.thStyle} onClick={() => handleSave(docs)}><FontAwesomeIcon style={{ color: '#663399' }} icon={faSave} className="fa-2xl" /></td>
                  <td style={customStyles.thStyle} onClick={() => handleDelete(docs)}><FontAwesomeIcon style={{ color: '#663399' }} icon={faDeleteLeft} className="fa-2xl" /></td>
                </tr>
              ))}
            </tbody>
          </table>
          <button onClick={handleNew}>Add New</button></>}
          
        </Modal>
        
      </div>
    </>
  );
}

Modal.setAppElement(document.getElementById('root'));
export default Planslucky;